import request from '@/utils/requestV2'
const qs = require('qs')

/**
 * 分页获取成本版本列表
 * @param {Object} data
 * @returns
 */
export function getVersionPage (data) {
  return request.post('/ooh-msp/v1/serviceversion/getVersionPage', qs.stringify(data))
}

/**
 * 创建一个新版本
 * @param {Object} data
 * @returns
 */
export function addVersion (data) {
  return request.post('/ooh-msp/v1/serviceversion/addVersion', qs.stringify(data))
}

/**
 * 更新版本名称
 * @param {Object} data
 * @returns
 */
export function updateVersionName (data) {
  return request.post('/ooh-msp/v1/serviceversion/updateVersionName', qs.stringify(data))
}

/**
 * 查询笔记信息列表
 * @param {Object} data
 * @returns
 */
export function getServiceNoteList (data) {
  return request.post('/ooh-msp/v1/serviceversion/getServiceNoteList', qs.stringify(data))
}

/**
 * 新增笔记
 * @param {Object} data
 * @returns
 */
export function addNote (data) {
  return request.post('/ooh-msp/v1/serviceversion/addNote', qs.stringify(data))
}

/**
 * 查询附件信息列表
 * @param {Object} data
 * @returns
 */
export function getServiceAttachList (data) {
  return request.post('/ooh-msp/v1/serviceversion/getServiceAttachList', qs.stringify(data))
}

/**
 * 新增附件
 * @param {Object} data
 * @returns
 */
export function addAttach (data) {
  return request.post('/ooh-msp/v1/serviceversion/addAttach', qs.stringify(data))
}

/**
 * 复制版本
 * @param {Object} data
 * @returns
 */
export function copyServiceVersion (data) {
  return request.post('/ooh-msp/v1/serviceversion/copyServiceVersion', qs.stringify(data))
}

/**
 * 删除版本
 * @param {Object} data
 * @returns
 */
export function deleteVersion (data) {
  return request.post('/ooh-msp/v1/serviceversion/deleteVersion', qs.stringify(data))
}

/**
 * 设置有效时间
 * @param {Object} data
 * @returns
 */
export function setVersionStartTime (data) {
  return request.post('/ooh-msp/v1/serviceversion/setVersionStartTime', qs.stringify(data))
}

/**
 * 查询供应商负责线路集合
 * @param {Object} data
 * @returns
 */
export function getCompanyAssetIdList (data) {
  return request.post('/ooh-msp/v1/serviceversion/getCompanyAssetIdList', qs.stringify(data))
}

/**
 * 新增或更新供应商线路
 * @param {Object} data
 * @returns
 */
export function saveOrUpdateCompanyAssets (params) {
  return request({
    url: '/ooh-msp/v1/serviceversion/saveOrUpdateCompanyAssets',
    method: 'post',
    data: params,
    headers: { 'Content-Type': 'application/json' }
  })
}

/**
 * 查询版本可用供应商列表
 * @param {Object} data
 * @returns
 */
export function getVersionEnabledCompany (data) {
  return request.post('/ooh-msp/v1/serviceversion/getVersionEnabledCompany', qs.stringify(data))
}

/**
 * 查询版本内指定公司可用线路列表
 * @param {Object} data
 * @returns
 */
export function getCompanyEnableAssetList (data) {
  return request.post('/ooh-msp/v1/serviceversion/getCompanyEnableAssetList', qs.stringify(data))
}

/**
 * 获取版本内容更新日志
 * @param {Object} data
 * @returns
 */
export function getServiceVersionModifyList (data) {
  return request.post('/ooh-msp/v1/serviceversion/getServiceVersionModifyList', qs.stringify(data))
}
